import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import {
  WEB_COMPONENT_COMPANY_BETA_PROGRAMS_TAB,
  WEB_COMPONENT_COMPANY_AUTHENTICATION_TAB,
  WEB_COMPONENT_COMPANY_DETAILS_TAB,
  WEB_COMPONENT_COMPANY_LICENSING_TAB,
  WEB_COMPONENT_PLANS_AND_PURCHASE_TAB,
} from '../../../../webcomponents.constants';
import { GzTabGroupWebComponent } from '../../../../ui/gzTabs/gzTabGroup';
import { GzTabWebComponent } from '../../../../ui/gzTabs/gzTab';
import { CompanyDetailsTabWebComponent } from '../../../common/companyDetailsTab';
import { CompanyAuthenticationTabWebComponent } from '../../../common/authenticationTab';
import { CompanyLicensingTabWebComponent } from '../../../common/licensingTab';
import { CompanyData } from '../../../types/company-data';
import { CompanyBetaProgramsTabWebComponent } from '../../../common/betaProgramsTab';
import { PlansAndPurchaseTabWebComponent } from '../../purchase/plansAndPurchaseTab';
import { Feature } from '@nirvana/shared/constants';
import { MyCompanyTabIndex } from '../../types/types';

export class MyCompanyPanelView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;

    $tabGroup: GzTabGroupWebComponent;

    $companyDetailsTab: GzTabWebComponent;
    $authenticationTab: GzTabWebComponent;
    $licensingTab: GzTabWebComponent;
    $betaProgramsTab: GzTabWebComponent;
    $plansAndPurchaseTab: GzTabWebComponent;

    $companyDetails: CompanyDetailsTabWebComponent;
    $authentication: CompanyAuthenticationTabWebComponent;
    $licensing: CompanyLicensingTabWebComponent;
    $betaPrograms: CompanyBetaProgramsTabWebComponent;
    $plansAndPurchase: PlansAndPurchaseTabWebComponent;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),

      $tabGroup: this.shadow.querySelector('#my-company-tab-group'),
      $companyDetailsTab: this.shadow.querySelector('#company-details-tab'),
      $authenticationTab: this.shadow.querySelector('#authentication-tab'),
      $licensingTab: this.shadow.querySelector('#licensing-tab'),
      $betaProgramsTab: this.shadow.querySelector('#beta-programs-tab'),
      $plansAndPurchaseTab: this.shadow.querySelector('#plans-and-purchase-tab'),

      $companyDetails: this.shadow.querySelector(WEB_COMPONENT_COMPANY_DETAILS_TAB),
      $authentication: this.shadow.querySelector(WEB_COMPONENT_COMPANY_AUTHENTICATION_TAB),
      $licensing: this.shadow.querySelector(WEB_COMPONENT_COMPANY_LICENSING_TAB),
      $betaPrograms: this.shadow.querySelector(WEB_COMPONENT_COMPANY_BETA_PROGRAMS_TAB),
      $plansAndPurchase: this.shadow.querySelector(WEB_COMPONENT_PLANS_AND_PURCHASE_TAB),
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.translations = this.stringsTranslator.getMyCompanyStrings();
    this.commonStrings = this.stringsTranslator.getCommonStrings();
  }

  setTranslatedStrings() {
    this.dom.$companyDetailsTab.label = this.translations.companyDetailsTitle;
    this.dom.$authenticationTab.label = this.translations.authenticationTitle;
    this.dom.$licensingTab.label = this.translations.licensingTitle;
    this.dom.$betaProgramsTab.label = this.translations.betaProgramsTitle;
    this.dom.$plansAndPurchaseTab.label = this.translations.plansAndPurchase;
  }

  buildSuccessView({ company }: { company: CompanyData }) {
    this.dom.$companyDetails.injectDependencies(this.dependencies);
    this.dom.$companyDetails.company = company;
    this.dom.$companyDetails.start().catch(console.error);

    this.dom.$authentication.companyId = company._id;
    this.dom.$authentication.injectDependencies(this.dependencies);
    this.dom.$authentication.start().catch(console.error);

    this.dom.$licensing.initialCompanyData = company;
    this.dom.$licensing.injectDependencies(this.dependencies);
    this.dom.$licensing.start().catch(console.error);

    this.dom.$betaPrograms.injectDependencies(this.dependencies);
    this.dom.$betaPrograms.start().catch(console.error);

    if (Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_IN_PRODUCT_BUY])) {
      this.dom.$tabGroup.showTabs([MyCompanyTabIndex.PlansAndPurchase]);
      this.dom.$plansAndPurchase.injectDependencies(this.dependencies);
      this.dom.$plansAndPurchase.start().catch(console.error);
    }

    this.showBetaProgramTab(company);
  }

  public showBetaProgramTab(company: CompanyData) {
    if (!company.specifics.features.cloudWorkloadSecurityStandalone) {
      this.dom.$tabGroup.showTabs([MyCompanyTabIndex.BetaPrograms]);
    }
  }

  public get hasUnsavedChanges(): boolean {
    return this.dom.$companyDetails.hasUnsavedChanges || this.dom.$authentication.hasUnsavedChanges;
  }
}
